<template>
  <div class="uk-container uk-margin-small-top">
    <h2 class="uk-heading-small uk-text-center">Select Styles</h2>
    <p class="uk-text-center uk-width-1-2@m uk-align-center">
      Select the patterns and designs you would like to add. Pick up to
      {{ maxSelections }} styles for our designers to add to your project.
    </p>

    <div id="stick-width" class="uk-align-center">
      <div
        class="uk-card uk-card-small uk-margin uk-card-default uk-card-body"
        uk-sticky=" bottom: #offset; width-element: #sticky-width; animation: uk-animation-slide-top; show-on-up: true;"
      >
        <p class="uk-margin-remove-bottom uk-text-small uk-text-muted">
          <center>Selected: {{ selectedProductCounts.total }}/8</center>
        </p>
        <ul uk-tab class="uk-flex-center uk-margin-remove-top">
          <li
            :class="{ 'uk-active': displayTies }"
            @click="setCurrentProductView('tie')"
          >
            <a href>
              Ties
              <span v-if="selectedProductCounts.ties > 0"
                >({{ selectedProductCounts.ties }})</span
              >
            </a>
          </li>
          <li
            :class="{ 'uk-active': displayBowTies }"
            @click="setCurrentProductView('bowTie')"
          >
            <a href>
              Bow Ties
              <span v-if="selectedProductCounts.bowTies > 0"
                >({{ selectedProductCounts.bowTies }})</span
              >
            </a>
          </li>
          <li
            :class="{ 'uk-active': displayPocketSquares }"
            @click="setCurrentProductView('pocketSquare')"
          >
            <a href>
              Pocket Squares
              <span v-if="selectedProductCounts.pocketSquares > 0"
                >({{ selectedProductCounts.pocketSquares }})</span
              >
            </a>
          </li>
          <li
            :class="{ 'uk-active': displayInfinityScarves }"
            @click="setCurrentProductView('infinityScarf')"
          >
            <a href>
              Infinity Scarves
              <span v-if="selectedProductCounts.infinityScarves > 0"
                >({{ selectedProductCounts.infinityScarves }})</span
              >
            </a>
          </li>
          <li
            :class="{ 'uk-active': displayChiffonScarves }"
            @click="setCurrentProductView('chiffonScarf')"
          >
            <a href>
              Chiffon Scarves
              <span v-if="selectedProductCounts.chiffonScarves > 0"
                >({{ selectedProductCounts.chiffonScarves }})</span
              >
            </a>
          </li>
          <li
            :class="{ 'uk-active': displayNeckGaiters }"
            @click="setCurrentProductView('neckGaiter')"
          >
            <a href>
              Neck Gaiters
              <span v-if="selectedProductCounts.chiffonScarves > 0"
                >({{ selectedProductCounts.neckGaiters }})</span
              >
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="uk-child-width-1-2 uk-child-width-1-4@m" uk-grid>
      <div v-for="pattern in displayedProducts">
        <div id="card" class="uk-card uk-card-default uk-card-small">
          <div
            class="uk-card-media-top"
            uk-toggle="target: #zoom-image"
            @click="setZoomImage(pattern)"
          >
            <a href="#">
              <img :src="pattern.image" alt />
            </a>
          </div>
          <div class="uk-card-body">
            <h4 class="uk-card-title uk-margin-small-bottom">
              <center>{{ pattern.patternName }}</center>
            </h4>
            <p
              class="uk-margin-small-bottom uk-margin-remove-top uk-text-muted"
            >
              <center>{{ _.startCase(pattern.productType) }}</center>
            </p>
            <button
              v-if="!styleIsSelected(pattern) && !maxSelected"
              class="uk-button uk-button-default uk-margin-remove uk-width-1-1"
              @click="selectStyle(pattern)"
            >
              Select
            </button>
            <button
              v-if="styleIsSelected(pattern)"
              class="uk-button uk-button-primary uk-margin-remove uk-width-1-1"
              @click="deselectStyle(pattern)"
            >
              remove
            </button>
            <button
              v-if="maxSelected && !styleIsSelected(pattern)"
              class="uk-button uk-button-default uk-margin-remove uk-width-1-1"
              disabled
            >
              maximum selected
            </button>
          </div>
        </div>
      </div>
    </div>

    <h3 class="uk-text-center uk-width-1-2@m uk-align-center">
      Need something more custom?
    </h3>
    <p class="uk-text-center uk-width-1-2@m uk-align-center">
      Our designers can create what you're looking for. Let us know about your
      design ideas here.
    </p>
    <div class="uk-width-1-2@m uk-align-center">
      <textarea
        v-model="designIdeas"
        class="uk-textarea uk-align-center"
        rows="5"
      ></textarea>

      <button
        v-if="!requestSubmitted"
        class="uk-button uk-button-primary uk-width-1-1"
        @click="submitNewPatterns"
      >
        Submit
      </button>
      <button
        v-if="requestSubmitted"
        class="uk-button uk-button-primary uk-width-1-1"
      >
        Request Submitted
      </button>
    </div>

    <div id="zoom-image" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-width-auto uk-margin-auto-vertical">
        <button class="uk-modal-close-outside" type="button" uk-close></button>
        <img :src="zoomImage" alt />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import firebase from "firebase";
import CrmService from "@/services/CrmService";

export default {
  name: "AddNewDesigns",
  data() {
    return {
      onboardingConfig: {
        formType: "organization",
        completedSteps: 1,
        totalSteps: 4
      },
      patterns: [],
      currentProductView: "tie",
      tempSelectedStyles: [],
      zoomImage: "",
      maxSelections: 8,
      designIdeas: "",
      projectID: "",
      requestSubmitted: false
    };
  },
  computed: {
    isActive() {
      return this.$store.state.newOrgProject.isActive;
    },
    displayedProducts() {
      var self = this;
      var currentPatterns = [];
      for (var i = 0; i < self.patterns.length; i++) {
        if (
          self.patterns[i].productType == _.camelCase(self.currentProductView)
        ) {
          currentPatterns.push(self.patterns[i]);
        }
      }
      return currentPatterns;
    },
    displayTies() {
      return this.currentProductView == "tie";
    },
    displayBowTies() {
      return this.currentProductView == "bowTie";
    },
    displayPocketSquares() {
      return this.currentProductView == "pocketSquare";
    },
    displayChiffonScarves() {
      return this.currentProductView == "chiffonScarf";
    },
    displayInfinityScarves() {
      return this.currentProductView == "infinityScarf";
    },
    displayNeckGaiters() {
      return this.currentProductView == "neckGaiter";
    },
    selectedProductCounts() {
      var self = this;
      var selectedCounts = {
        ties: 0,
        bowTies: 0,
        pocketSquares: 0,
        infinityScarves: 0,
        chiffonScarves: 0,
        neckGaiters: 0,
        total: 0
      };
      for (var i = 0; i < self.tempSelectedStyles.length; i++) {
        self.tempSelectedStyles[i];
        if (self.tempSelectedStyles[i].productType == "tie") {
          selectedCounts.ties += 1;
        } else if (self.tempSelectedStyles[i].productType == "bowTie") {
          selectedCounts.bowTies += 1;
        } else if (self.tempSelectedStyles[i].productType == "pocketSquare") {
          selectedCounts.pocketSquares += 1;
        } else if (self.tempSelectedStyles[i].productType == "infinityScarf") {
          selectedCounts.infinityScarves += 1;
        } else if (self.tempSelectedStyles[i].productType == "chiffonScarf") {
          selectedCounts.chiffonScarves += 1;
        } else if (self.tempSelectedStyles[i].productType == "neckGaiter") {
          selectedCounts.neckGaiters += 1;
        }
        selectedCounts.total += 1;
      }
      return selectedCounts;
    },
    maxSelected() {
      var self = this;
      if (self.selectedProductCounts.total == self.maxSelections) {
        return true;
      } else {
        return false;
      }
    },
    canContinue() {
      var self = this;
      if (self.selectedProductCounts.total > 0 || self.designIdeas != "") {
        return true;
      }
    },
    selectedStyles() {
      return this.$store.state.newOrgProject.selectedStyles.styles;
    },
    noteObject() {
      let patterns = "";
      for (let index = 0; index < this.tempSelectedStyles.length; index++) {
        const element = this.tempSelectedStyles[index];
        patterns += element.patternName + ", " + element.productType + " / ";
      }
      patterns += this.designIdeas;
      let note = {
        dealID: this.projectID,
        proofID: "",
        note: patterns
      };
      return note;
    }
  },
  mounted: function() {
    this.getPatterns();
    this.projectID = this.$route.params.id;
  },
  methods: {
    setCurrentProductView(product) {
      this.currentProductView = product;
    },
    styleIsSelected(pattern) {
      var self = this;
      for (var i = 0; i < this.tempSelectedStyles.length; i++) {
        if (
          self.tempSelectedStyles[i].patternName == pattern.patternName &&
          self.tempSelectedStyles[i].productType == pattern.productType
        ) {
          return true;
        }
      }
    },
    selectStyle(pattern) {
      var self = this;
      self.tempSelectedStyles.push(pattern);
    },
    deselectStyle(pattern) {
      var self = this;
      for (var i = 0; i < self.tempSelectedStyles.length; i++) {
        if (self.tempSelectedStyles[i] == pattern) {
          self.tempSelectedStyles.splice(i, 1);
        }
      }
    },
    setZoomImage(pattern) {
      this.zoomImage = pattern.image;
    },
    setSelectedStyles() {
      this.$store.commit(
        "newOrgProject/setSelectedStyles",
        this.tempSelectedStyles
      );
    },
    getPatterns() {
      var self = this;
      self.patterns = [];
      firebase
        .firestore()
        .collection("orgPatterns")
        .orderBy("patternName")
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            // doc.data() is never undefined for query doc snapshots
            let data = doc.data();
            let pattern = {
              patternName: data.patternName,
              image: data.image,
              productType: data.productType,
              id: doc.id
            };
            self.patterns.push(pattern);
          });
        });
    },
    submitNewPatterns() {
      var self = this;
      CrmService.revisionRequest(this.noteObject);
      this.requestSubmitted = true;
      setTimeout(function() {
        self.$router.push({
          name: "ProjectView",
          params: { id: self.projectID }
        });
      }, 1500);
    }
  }
};
</script>

<style type="text/css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/design-portal/AddNewDesigns.vue